export const SOFTLINE_API_INVENTORY_GET_ACTIVE = '/v1/inventur';
export const SOFTLINE_API_INVENTORY_ITEMS = '/v1/inventur/bewegung/entities';
export const SOFTLINE_API_INVENTORY_SUBMIT = '/v1/inventur/abschluss';
export const SOFTLINE_API_MDE_INVENTUR_LAGERPLATZ_SCAN = '';
export const SOFTLINE_API_INVENTORY_DEFAULT_STORAGE = '/v1/inventur/lager';
export const SOFTLINE_API_INVENTORY_ITEMS_UPDATE =
  '/v1/inventur/bewegung/entities/{{id}}';
export const SOFTLINE_API_INVENTORY_GET_ITEM_DETAIL =
  '/v1/inventur/artikel/entities/{{id}}/detail';
